exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-488702ce]{text-decoration:none;color:#000}.folding-box[data-v-488702ce]{border:.5px solid #d9dde1;font-size:20px}.folding-close[data-v-488702ce]{height:0;overflow:hidden;-webkit-transition:all .5s ease-in-out;transition:all .5s ease-in-out}thead[data-v-488702ce]{font-size:15px;background-color:#d9dde1}tbody[data-v-488702ce]{background-color:ivory;font-size:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-488702ce","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Personal/MyNotes.vue
// module id = sX46
// module chunks = 1